import { COMP_COVERS_NEW } from './../Models/COMP_COVERS_NEW';
import {Injectable, Pipe, PipeTransform} from '@angular/core';


@Pipe({
  name: 'compManCovers',
  pure:false
})
@Injectable()
export class compManCovers implements PipeTransform {
  transform(compManCovers: Array<COMP_COVERS_NEW>, sel:boolean): any {
    return compManCovers.filter(t => t.IsMandatory==sel);
  }
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pipes/compManCovers.ts